// export default () => ({
// })

export default () => ({
    inputs: [],
    inputsSelectable: [],
    inputSelect: null,
    inputsPaginatedData: null,
    input: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})